import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import {
    articleKey,
    bonusReportKey,
    tradeAlertKey,
    tspLessonsKey,
    tspProductKey,
    tutorialsKey,
    webinarKey,
    tspModelPortfolioKey
} from "@/types/products/product-definitions";

// Non-reactive variables
import {
    configureProductActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers";

const initialView: string = tspModelPortfolioKey;
const selectedView = ref< string >( initialView );

const productConfig: ProductConfig = {
    slug: tspProductKey
}

const productActionTopicKeys = [
    bonusReportKey,
    tspModelPortfolioKey,
    articleKey,
    tradeAlertKey,
    webinarKey,
    tspLessonsKey,
    tutorialsKey
];

export function useTrueSovereignProfits() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( tspProductKey, productActionTopicKeys );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        selectedView
    }
}
